import styled from 'styled-components';

const Header = styled.header`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 80px;
  padding: 0 16px;
  color: ${props => props.theme.palette.primary.main};
  background: ${props => props.theme.palette.background.default};
  position: sticky;
  top: 0;
  z-index: 1;
  @media screen and (max-width: ${props => props.theme.breakpoints.values.md}px) {
    height: 56px;
  }
`;

export default Header;

export const MobileHeader = styled(Header)`
  display: none;
  @media screen and (max-width: ${props => props.theme.breakpoints.values.md}px) {
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
  }
`;

export const DesktopHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${props => props.theme.breakpoints.values.md}px) {
    display: none;
  }
`;
